import React from 'react';
import DepartmentForm from './DepartmentForm';
import { modifyDepartment } from '../../api';
import { connect } from 'react-redux';
import { onModificationSuccess } from './util';

const onSubmit = (values, department) => Object.assign({}, department, values);

const mapStateToProps = (state) => (
  {
    name: 'modifyDepartment',
    id: state.app.departments.detail.id,
    selectedObject: state.app.departments.detail,
    request: modifyDepartment,
    initialValues: state.app.departments.detail,
    onSubmit,
    onSuccess: onModificationSuccess,
  }
);

const DepartmentDetail = connect(
  mapStateToProps
)(DepartmentForm);

export default DepartmentDetail;

export class Department extends React.Component {

  render() {
    return (
      <DepartmentDetail
        appBar={{
          title: 'DEPARTMENT',
          navigateBack: true,
        }}
      />
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Department/Department.js
 **/